var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cp-select',_vm._g(_vm._b({attrs:{"config":_vm.configUsers,"item-value":"id","item-text":"name","clearable":"","customSelection":true},scopedSlots:_vm._u([{key:"selection",fn:function({ item }){return undefined}}])},'cp-select',_vm.attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }